export default __webpack_public_path__ + "static/media/credit-card-CID.dcd7f67e.svg";